import { Box, Paper, Radio, Stack, Typography } from '@mui/material';

interface InventoryChoiceProps {
  selected: boolean;
  title: string;
  caption: string;
  onClick: () => void;
}

const InventoryChoice = ({ selected, title, caption, onClick }: InventoryChoiceProps) => (
  <Paper variant="outlined" onClick={onClick} sx={{ flex: 1, cursor: 'pointer', borderColor: selected ? 'primary.main' : 'divider' }}>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 1 }}>
      <Radio checked={selected} />
      <Box>
        <Typography variant="caption" color="text.secondary">{caption}</Typography>
        <Typography variant="subtitle2">{title}</Typography>
      </Box>
    </Stack>
  </Paper>
);

export default InventoryChoice;
